<template>
    <div class="about">
        <h1>A simple site built using Vue3</h1>
    </div>
</template>
